'use strict';

function getFetchResponseCookies(response) {
  const headersObj = new Headers(response.headers);
  const cookies = [...headersObj.getSetCookie()];
  return cookies.reduce((acc, cookie) => {
    const [name, value] = cookie.split(';')[0].split('=');
    acc[name] = value;
    return acc;
  }, {});
}

exports.getFetchResponseCookies = getFetchResponseCookies;
